(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/Image"), require("../../components/Text"), require("../../utils/css-validator"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/Image", "../../components/Text", "../../utils/css-validator"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/Image"), require("../../components/Text"), require("../../utils/css-validator")) : factory(root["../../components/Image"], root["../../components/Text"], root["../../utils/css-validator"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__74__, __WEBPACK_EXTERNAL_MODULE__86__, __WEBPACK_EXTERNAL_MODULE__948__) {
return 